import { render } from "./Authentification.vue?vue&type=template&id=4367ae42&ts=true&lang=pug"
import script from "./Authentification.vue?vue&type=script&lang=ts"
export * from "./Authentification.vue?vue&type=script&lang=ts"

import "./Authentification.vue?vue&type=style&index=0&id=4367ae42&lang=scss"

import exportComponent from "/Users/olimago/Documents/www/escape-if-you-can-01/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__